import { Directive, ElementRef, HostListener, OnInit, input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { NumberMaskPipe } from '../pipes/number-mask.pipe';

@Directive({
    selector: '[pghNumber]',
    standalone: true,
    providers: [NumberMaskPipe]
})
export class InputNumberDirective implements OnInit {
  constructor(
    private elementRef: ElementRef,
    private numberMask: NumberMaskPipe,
    private ngControl: NgControl
  ) {
    this._nativeRef = this.elementRef.nativeElement;
  }

  private _nativeRef: HTMLInputElement;

  readonly pattern = input(undefined, { alias: "pghNumber" });
  readonly maxLength = input(undefined, { alias: "pghNumberLength" });
  readonly hideValue = input(false, { alias: "pghNumberHideValue" });

  ngOnInit() {
    const pattern = this.pattern();
    if (pattern) {
      this._nativeRef.value = this.numberMask.transform(this._nativeRef.value, pattern);
    }

    if (this.hideValue() && this._nativeRef?.value) {
      this._nativeRef.value = this._nativeRef.value.replace(/\d/g, '•');
    }
  }

  @HostListener('input', ['$event.target.value'])
  onInputChange(value: string) {
    const maxLength = this.maxLength();
    if (maxLength) {
      this.ngControl.control.setValue(value.replace(/[^0-9]/g, '').slice(0, maxLength));
    } else {
      this.ngControl.control.setValue(value.replace(/[^0-9]/g, ''));
    }

    const pattern = this.pattern();
    if (pattern) {
      this._nativeRef.value = this.numberMask.transform(this.ngControl.value, pattern);
    }
  }

  @HostListener('focus')
  onFocus() {
    if (this.hideValue()) {
      this._nativeRef.value = this.numberMask.transform(this.ngControl.value, this.pattern());
    }
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    if (this.hideValue()) {
      this._nativeRef.value = value.replace(/\d/g, '•');
    }
  }
}
